import type { RutterConnectionStatus } from "./enums";

export const ConnectionState = {
  healthy: "healthy",
  unhealthy: "unhealthy",
  none: "none",
} as const;

export type ConnectionState =
  (typeof ConnectionState)[keyof typeof ConnectionState];

const healthyStatuses: string[] = ["initial", "updated", "created"];

export function getConnectionState(
  connection:
    | { status?: string | null | RutterConnectionStatus }
    | null
    | undefined,
): ConnectionState {
  if (!connection) return ConnectionState.none;
  if (!connection.status) return ConnectionState.none;
  return healthyStatuses.includes(connection.status)
    ? ConnectionState.healthy
    : ConnectionState.unhealthy;
}
